import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../Icon';
import KubitTooltip from '../../../KubitTooltip';
import { theme } from '../../../../styles/theme';
import { overflowingStyles } from '../../../../styles/shareableStyles';

interface IProps {
  tableNames: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: ${theme.colors.secondary600};
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;
const NamesWrapper = styled.div`
  flex: 1;
  max-width: 100%;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.6;
  ${overflowingStyles};
`;

const TableNames = ({ tableNames }: IProps) => {
  return (
    <KubitTooltip
      content={tableNames}
      placement="bottom-start"
      noOpenDelay={true}
    >
      <Container>
        <SvgIcon
          name="table"
          width={16}
          height={16}
          customFill="currentColor"
        />
        <NamesWrapper>{tableNames}</NamesWrapper>
      </Container>
    </KubitTooltip>
  );
};

export default TableNames;
